// extracted by mini-css-extract-plugin
module.exports = {"statusChip":"StatusChip_statusChip__2dK9_","completed":"StatusChip_completed__3FTFk","missing_information":"StatusChip_missing_information__1z4WP"};